import { JetView } from 'webix-jet';

/**
 * DatesView class extends JetView to create a calendar component.
 */
export default class DatesView extends JetView {
    /**
     * Configures the calendar view.
     * @returns {Object} Configuration object for the calendar.
     */
    config() {
        const screen = this.app.config.size; // Retrieves the current screen size
        return {
            view: 'calendar', // Specifies the view type as calendar
            width: screen !== 'small' ? 250 : 230, // Sets width based on screen size
            height: screen !== 'small' ? 250 : 230, // Sets height based on screen size
            on: {
                /**
                 * Event handler for date selection.
                 * @param {Date} date - The selected date.
                 */
                onDateSelect: (date) => this.app.callEvent('date:select', [date]), // Calls event with selected date
            },
        };
    }

    /**
     * Initializes the DatesView instance.
     * @param {Object} calendar - The calendar component instance.
     */
    init(calendar) {
        this.on(this.app, 'taction:select', (record) => {
            if (record) calendar.setValue(record.date); // Sets calendar value if record exists
        });
    }
}

// FILE DOCUMENTED
